module.exports = __webpack_public_path__ + "img/1.22301172.png";